import { render, staticRenderFns } from "./FormChooseProductInputAnswer.vue?vue&type=template&id=4f3e0c58&scoped=true"
import script from "./FormChooseProductInputAnswer.vue?vue&type=script&lang=js"
export * from "./FormChooseProductInputAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3e0c58",
  null
  
)

export default component.exports